import React from 'react';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
interface Props {
	tab: PositionCandidatesTabsEnum;
	setTab: (arg: PositionCandidatesTabsEnum) => void;
	totalConections: number;
	onChange?: (value: PositionCandidatesTabsEnum) => void;
	isTourActive: boolean;
}

export enum PositionCandidatesTabsEnum {
	RECOMMENDATIONS = 'recommendations',
	SHORTLISTED = 'shortlisted',
	CONNECTED = 'connected',
}

const PositionCandidateListingTabs = ({ isTourActive, tab, setTab, totalConections, onChange }: Props) => {
	const location = useLocation();
	return (
		<>
			<div className="flex w-full md:max-w-[500px] dark:bg-[#1F2A37]">
				<button
					className={`walkthrough-first-element ${
						tab === PositionCandidatesTabsEnum.RECOMMENDATIONS
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-l-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_active',
							eventLabel: location.pathname,
						});
						setTab(PositionCandidatesTabsEnum.RECOMMENDATIONS);
						onChange && onChange(PositionCandidatesTabsEnum.RECOMMENDATIONS);
					}}
				>
					All Candidates
				</button>
				<button
					className={`walkthrough-first-element ${
						tab === PositionCandidatesTabsEnum.SHORTLISTED
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_active',
							eventLabel: location.pathname,
						});
						setTab(PositionCandidatesTabsEnum.SHORTLISTED);
						onChange && onChange(PositionCandidatesTabsEnum.SHORTLISTED);
					}}
				>
					Shortlisted {`(${totalConections})`}
				</button>
				<button
					className={`walkthrough-second-element ${
						tab === PositionCandidatesTabsEnum.CONNECTED
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-r-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_closed',
							eventLabel: location.pathname,
						});
						setTab(PositionCandidatesTabsEnum.CONNECTED);
						onChange && onChange(PositionCandidatesTabsEnum.CONNECTED);
					}}
				>
					Pipeline
				</button>
			</div>
		</>
	);
};

export default PositionCandidateListingTabs;
